function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { rem } from 'polished';
import React from 'react';
import Box from '../Box';
const ShippoIcon = _ref => {
  let {
    size,
    bg,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 414 414",
    width: rem(size),
    height: rem(size),
    fill: bg,
    verticalAlign: "middle"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M219.5 157.3c-5.8 4.2-13.5 4.5-19.6.7-5.9-3.6-9-10.4-7.8-17.2.1-.7.3-1.5.6-2.2-.7 2-1.4 3.7.1-.3s.9-2.3.1-.3c2.7-6.3 8.9-10.4 15.8-10.2 7.2.1 13.6 4.6 16.2 11.3 2.3 6.7.2 14-5.4 18.2zm187.7-24.1c-5.4-13-14.1-24.4-25.2-33-11.8-9-25.8-14.8-40.5-16.7-8.6-1.1-17.2-1-25.8.4-8.8 1.6-17.4 4.2-25.6 7.9-4 1.7-8 3.5-12.1 5.3a83 83 0 01-40.6 11.6c-7.4.1-14.9-.7-22.1-2.3-3.8-.8-7.6-1.9-11.3-3.1-3.6-1.2-7.3-1.9-11.1-2.2-8.6-.7-17.3.4-25.8 1.3l-20.6 2.2-.1-.1-.6.1c-5.2-5.8-11.7-10.3-18.1-14.8-1.7-1.4-3.7-2.3-5.8-2.6-6.4-.1-8 7.6-8.3 12.6-.4 6.1.2 12.3 1.6 18.2.4 2.3 1.2 4.6 2.2 6.7.7 2.9 1.6 5.7 2.7 8.5-2.2 2.7-4 5.8-5.3 9.1-.4 1.1-.9 2.2-1.6 3.2-2.1 3-4.4 5.9-6.8 8.6-8.1 9.3-16.7 18.2-25.3 27.1-4 4.1-38.8 15.6-58.8 22 1.4-66 41.2-125.2 101.8-151.4s131-14.6 180 29.6c3.5-1 7.1-1.8 10.7-2.4 5-.8 10.1-1.2 15.2-1.2h2.3c-36.2-39.7-87.5-62.3-141.2-62.2C85.6 15.5 0 101.1 0 206.7S85.6 398 191.2 398c97.3 0 177.5-72.6 189.7-166.5-1 .6-2 1.2-3.1 1.8-4.7 2.5-9.6 4.8-14.6 6.7-1.7.7-3.2 1.3-4.8 2l-2.2 1c-16.4 74.9-81.3 129.3-157.9 132.5 16.8-25 50.4-74 60.3-80.8 13.5-9.2 27.2-18.3 41.1-26.9 12.7-7.9 25.7-15.4 39.1-22.2 5.8-3 11.7-5.7 17.7-8.3 6.4-2.7 12.9-5 18.9-8.4a77.01 77.01 0 0027-25.3c6.4-10.1 10.2-21.6 11.1-33.6.7-12.6-1.4-25.2-6.3-36.8z"
  }));
};
ShippoIcon.defaultProps = {
  size: 16,
  bg: '#A4D55D'
};
export default ShippoIcon;